export default {
  loading: 'Loading...',
  // header
  aboutus: 'Tentang Kami',
  vision_and_mission: 'Visi dan Misi',
  why_sistesi: 'Mengapa Sistesi',
  product: 'Produk',
  // footer
  about_exi: 'Tentang Exi Global Aplikasi',
  followus: 'Ikuti Kami',
  contact_us: 'Hubungi Kami',
  others: 'Lainnya',
  privacy_policy: 'Kebijakan Privasi',
  term_and_condition: 'Syarat dan Ketentuan',
  error: {
    title: 'Oops, 404',
    text: 'Halaman yang Anda cari tidak ada',
    text_btn: 'Kembali ke halaman utama',
  },
  home: {
    company_profile: 'merupakan software manajemen sekolah yang mampu mencatat history siswa (biodata, nilai, konseling, ekstrakulikuler, keuangan/SPP, pinjaman buku, presensi, dan lain lain) dari Siswa masuk hingga lulus atau keluar dari sekolah tersebut. Selain itu SISTesi dilengkapi dengan Sistem Ujian secara Online/ Paperless. SISTesi juga kami integrasikan dengan teknologi RFID dalam bentuk Kartu Pintar Multifungsi.',
    company_profile_download: 'Unduh Aplikasi SISTesi',
    vision: {
      text_title: 'Visi dan Misi Kami',
      text_detail: 'Menjadikan SISTESI sebagai solusi total yang terus berinovasi untuk mengatasi permasalahan dan tantangan yang dihadapi lembaga pendidikan di masa kini dan di masa depan.',
      text_a: 'Mengaplikasikan solusi sistesi sebagai platform manajemen operasional, sistem informasi dan pusat kegiatan ekonomi di lembaga pendidikan nasional.',
      text_b: 'Mengadakan pelatihan secara berkala terhadap semua SDM sekolah untuk pengaplikasian solusi sistesi dan program pendidikan lainnya.',
      text_c: 'Melakukan penelitian dan pengembangan terhadap teknologi perangkat lunak dan perangkat keras untuk terus berinovasi.',
      text_d: 'Menyerap aspirasi para tenaga didik, masyarakat dan siswa didik untuk pengembangan pelayanan SISTESI mengikuti perkembangan jaman dan teknologi.',
      text_e: 'Menggandeng pihak ketiga untuk berkolaborasi dalam penambahan fitur layanan yang berdaya guna dan bermanfaat bagi semua stakeholder SISTESI.',
    },
    value: {
      title: 'Mengapa SISTesi',
      text_a: 'Dashboard Monitoring',
      text_b: 'Keamanan',
      text_c: 'Terintegrasi',
    },
    product: {
      title: 'Produk SISTesi',
      tagline: '* per bulan per anak',
      btn_plan: 'LIHAT ISI PAKET',
      text_lite_1: 'Fitur Admin (SIM) Sekolah & Guru',
      text_lite_2: 'Fitur Ortu/Wali/Siswa/i',
      text_lite_3: 'Harga berlaku untuk seluruh indonesia',
      text_basic_1: 'Fitur Admin (SIM) Sekolah & Guru',
      text_basic_2: 'Fitur Ortu/Wali/Siswa/i',
      text_basic_3: 'Gratis Hardware & Gratis Kartu ID Siswa/i',
      text_basic_4: 'Untuk Siswa/i yang mendaftar pertama kali',
      text_basic_5: 'Harga khusus Jawa & Bali',
      text_basic_6: 'Harga diluar Jawa & Bali 23.000 termasuk PPN',
      text_subscribe_1: 'Fitur Admin (SIM) Sekolah & Guru',
      text_subscribe_2: 'Fitur Ortu/Wali/Siswa/i',
      text_subscribe_3: 'Untuk Ortu/Wali/Siswa/i yang subscribe sebesar Rp 15.000',
      text_price_for_java: '* harga sudah termasuk PPN',
      text_free: 'Gratis e-Learning dan e-Test',
      text_phone: 'Promo lebih lanjut silahkan hubungi marketing kami di',
      footer: 'Harga di luar pulau Jawa dan Bali dikenakan tambahan biaya sebesar Rp 6.000 sebelum PPn 10%',
    },
  },
  contact: {
    title: 'Kontak Kami',
    tagline: 'Saran, komentar atau pertanyaan terkait produk atau pelayanan kami dapat ditujukan kepada kami melalui nomor telepon +62 21 766-9525 atau e-mail ke info@sistesi.id.',
  },
};
